import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from '../api.service';
import { LandingPageService } from '../landing-page.service';
import { UserService } from '../user.service';

import { Course } from '../course.model';
// import { SURVEY_GIZMO_SAML_LOGIN_URL } from '../../constants'
import moment from "moment";

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        // private router: Router
        private apiService: ApiService,
        private landingPageService: LandingPageService,
        private userService: UserService,
    ) {}

    id:number;
    course:Course;
    isLoaded:boolean = false;
    loadingError:boolean = false;
    errorMsg = '';
    
    ngOnInit() {
        this.id = parseInt(this.route.snapshot.paramMap.get('id'));
        
        if ( !this.id ){
            this.errorMsg = "The course id provided is not valid"
            this.isLoaded = true
            return;
        }
        
        this.course = new Course({id: this.id})
        this.getCourse();
    }

    getCourse() {
        this.apiService.getCourse(this.course).subscribe(
            data => {
                this.course = new Course(data)
                this.userService.isEnrolled = (data.casce_event_registration.length > 0 || data.casce_event_olr2_registration.length > 0);
                this.landingPageService.isOneDayEvent = moment(this.course.startDate, 'MM/D/YYYY').isSame(moment(this.course.endDate, 'MM/D/YYYY'), 'day');

                if ( !this.userService.isAdmin && !this.userService.isEnrolled ) {
                    this.userService.deny();
                    return;
                }

                this.isLoaded = true
            },
            error => {
                this.loadingError = true
                this.errorMsg = error
                this.isLoaded = true

            }
        )
    }

    open(url){
        window.open(url, "_blank");
    }

    get showVendors (){
        return this.landingPageService.showVendors;
    }
    
    get isAuthorized (){
        return this.userService.isAuthorized;
    }

    get isOneDayEvent (){
        return this.landingPageService.isOneDayEvent;
    }
    
}
